export class Root {
  constructor(public files: (File | Folder)[] = []) {}
}

export class Folder {
  constructor(
    public name: string,
    public files: (File | Folder)[] = [],
  ) {}

  find(name: string) {
    return this.files.find((f) => f.name == name);
  }

  addFolder(name: Folder) {
    this.files.push(name);
  }

  addFile(file: File) {
    this.files.push(file);
  }
}

export class File {
  constructor(
    public name: string,
    public format: string,
  ) {}
}

function rec(folder: Folder, parts: string[]) {
  if (parts == undefined || parts.length == 0 || parts[0] == undefined)
    return folder;

  if (parts.length == 1) {
    // add file
    const dot = parts[0].lastIndexOf(".");

    if (dot > 0) {
      const name = parts[0].substring(0, dot);
      const format = parts[0].substring(dot + 1);
      const newFile = new File(name, format);
      folder.addFile(newFile);
    } else {
      const newFile = new File(parts[0], "");
      folder.addFile(newFile);
    }
    return folder;
  }

  const nextFolder = folder.find(parts[0]);
  if (nextFolder != undefined && nextFolder instanceof Folder) {
    rec(nextFolder, parts.slice(1));
  } else {
    const newFolder = new Folder(parts[0]);
    folder.addFolder(newFolder);
    rec(newFolder, parts.slice(1));
  }
}

export function build(entries: string[]): Folder {
  const root = new Folder("");

  for (const entry of entries) {
    const sections = entry.split("/");
    rec(root, sections);
  }

  return root;
}

export function render(prefix: string, root: Folder) {
  var s = "";
  for (const f of root.files) {
    if (f === root.files.at(root.files.length - 1)) {
      // last item
      if (f instanceof Folder) {
        s += `${prefix}  └── ${f.name}\n`;
        // console.log(`${prefix}  └── ${f.name}`);
        s += render(`${prefix}   `, f);
      } else {
        if (f.format != "") {
          s += `${prefix}  └── ${f.name}.${f.format}\n`;
        //   console.log(`${prefix}  └── ${f.name}.${f.format}`);
        } else {
          s += `${prefix}  └── ${f.name}\n`;
        //   console.log(`${prefix}  └── ${f.name}`);
        }
      }
    } else {
      // middle item
      if (f instanceof Folder) {
        s += `${prefix}  ├── ${f.name}\n`;
        // console.log(`${prefix}  ├── ${f.name}`);
        s += render(`${prefix}  │`, f);
      } else {
        if (f.format != "") {
          s += `${prefix}  ├── ${f.name}.${f.format}\n`;
        //   console.log(`${prefix}  ├── ${f.name}.${f.format}`);
        } else {
          s += `${prefix}  ├── ${f.name}\n`;
        //   console.log(`${prefix}  ├── ${f.name}`);
        }
      }
    }
  }
  return s;
}
